import Toast from './toast';
import './toast.scss';

export default Toast;
